/* ==========================================================================
   Unknown Kits Theme - JavaScript
   ========================================================================== */

(function() {
  'use strict';

  /* ========================================================================
     Countdown Timer
     ======================================================================== */
  function initCountdown() {
    const countdownEl = document.getElementById('announcement-countdown');
    if (!countdownEl) return;

    const useEndDate = countdownEl.dataset.useEndDate === 'true';
    let endTime;

    if (useEndDate && countdownEl.dataset.endDate) {
      endTime = new Date(countdownEl.dataset.endDate).getTime();
    } else {
      const hours = parseInt(countdownEl.dataset.hours) || 3;
      const minutes = parseInt(countdownEl.dataset.minutes) || 0;
      const storageKey = 'uk_countdown_end';
      const stored = localStorage.getItem(storageKey);

      if (stored && parseInt(stored) > Date.now()) {
        endTime = parseInt(stored);
      } else {
        endTime = Date.now() + (hours * 3600000) + (minutes * 60000);
        localStorage.setItem(storageKey, endTime.toString());
      }
    }

    const daysEl = document.getElementById('countdown-days');
    const hoursEl = document.getElementById('countdown-hours');
    const minsEl = document.getElementById('countdown-minutes');
    const secsEl = document.getElementById('countdown-seconds');

    function pad(n) {
      return n < 10 ? '0' + n : n.toString();
    }

    function updateCountdown() {
      const now = Date.now();
      let diff = endTime - now;

      if (diff <= 0) {
        diff = 0;
        // Reset the countdown for a new cycle
        const hours = parseInt(countdownEl.dataset.hours) || 3;
        const minutes = parseInt(countdownEl.dataset.minutes) || 0;
        const newEnd = Date.now() + (hours * 3600000) + (minutes * 60000);
        localStorage.setItem('uk_countdown_end', newEnd.toString());
        endTime = newEnd;
        diff = endTime - Date.now();
      }

      const days = Math.floor(diff / 86400000);
      const hrs = Math.floor((diff % 86400000) / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hrs);
      if (minsEl) minsEl.textContent = pad(mins);
      if (secsEl) secsEl.textContent = pad(secs);
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* ========================================================================
     Sticky Header - Show on Scroll Up, Hide on Scroll Down
     ======================================================================== */
  function initStickyHeader() {
    const header = document.getElementById('site-header');
    if (!header) return;

    const isTransparent = header.dataset.transparent === 'true';
    const isSticky = header.dataset.sticky === 'true';
    if (!isSticky) return;

    const announcementBar = document.getElementById('announcement-bar');
    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
    const headerHeight = header.offsetHeight;
    const triggerPoint = announcementHeight + headerHeight;

    let lastScrollY = window.scrollY;
    let ticking = false;

    function onScroll() {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= announcementHeight) {
        // At the top: restore original state
        header.classList.remove('site-header--scrolled', 'site-header--hidden', 'site-header--visible');
        if (isTransparent) {
          header.style.position = 'absolute';
          header.style.top = announcementHeight + 'px';
        }
      } else if (currentScrollY > lastScrollY && currentScrollY > triggerPoint) {
        // Scrolling DOWN past trigger: hide header
        header.classList.add('site-header--scrolled', 'site-header--hidden');
        header.classList.remove('site-header--visible');
        if (isTransparent) {
          header.style.position = 'fixed';
          header.style.top = '0';
        }
      } else if (currentScrollY < lastScrollY) {
        // Scrolling UP: show sticky header
        header.classList.add('site-header--scrolled', 'site-header--visible');
        header.classList.remove('site-header--hidden');
        if (isTransparent) {
          header.style.position = 'fixed';
          header.style.top = '0';
        }
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });

    // Initial position for transparent header
    if (isTransparent) {
      header.style.position = 'absolute';
      header.style.top = announcementHeight + 'px';
    }
  }

  /* ========================================================================
     Mobile Menu Toggle
     ======================================================================== */
  function initMobileMenu() {
    const toggle = document.getElementById('mobile-menu-toggle');
    const mobileNav = document.getElementById('mobile-nav');
    const overlay = document.getElementById('mobile-nav-overlay');
    const closeBtn = document.getElementById('mobile-nav-close');
    if (!toggle || !mobileNav) return;

    function openMenu() {
      mobileNav.classList.add('is-open');
      mobileNav.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      mobileNav.classList.remove('is-open');
      mobileNav.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    var scrollBlocked = false;
    var scrollBlockTimer = null;

    window.addEventListener('scroll', function() {
      scrollBlocked = true;
      clearTimeout(scrollBlockTimer);
      scrollBlockTimer = setTimeout(function() {
        scrollBlocked = false;
      }, 600);
    }, { passive: true });

    toggle.addEventListener('click', function() {
      if (scrollBlocked) return;
      if (mobileNav.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* ========================================================================
     Cart Drawer
     ======================================================================== */
  function initCartDrawer() {
    const trigger = document.getElementById('cart-drawer-trigger');
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-drawer-overlay');
    const closeBtn = document.getElementById('cart-drawer-close');
    const continueBtn = document.getElementById('cart-continue-shopping');

    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('cart-open');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('cart-open');
    }

    if (trigger) trigger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (continueBtn) continueBtn.addEventListener('click', closeDrawer);

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // Quantity buttons and remove buttons
    drawer.addEventListener('click', function(e) {
      const qtyBtn = e.target.closest('.cart-drawer__qty-btn');
      const removeBtn = e.target.closest('.cart-drawer__remove');

      if (qtyBtn) {
        const key = qtyBtn.dataset.key;
        const action = qtyBtn.dataset.action;
        const item = qtyBtn.closest('.cart-drawer__item');
        const qtyEl = item.querySelector('.cart-drawer__qty-value');
        let qty = parseInt(qtyEl.textContent);

        if (action === 'increase') qty++;
        if (action === 'decrease') qty = Math.max(0, qty - 1);

        updateCartItem(key, qty);
      }

      if (removeBtn) {
        const key = removeBtn.dataset.key;
        updateCartItem(key, 0);
      }
    });

    // Size change in cart drawer
    drawer.addEventListener('change', function(e) {
      var select = e.target.closest('.cart-drawer__size-select');
      if (!select) return;

      var oldKey = select.dataset.key;
      var newVariantId = parseInt(select.value);
      var qty = parseInt(select.dataset.qty) || 1;
      var properties = {};

      try {
        var propsRaw = JSON.parse(select.dataset.properties || '{}');
        if (propsRaw && typeof propsRaw === 'object') {
          // propsRaw can be { "Name on shirt": "Messi", ... } or array format
          if (Array.isArray(propsRaw)) {
            propsRaw.forEach(function(p) { if (p[1]) properties[p[0]] = p[1]; });
          } else {
            Object.keys(propsRaw).forEach(function(k) { if (propsRaw[k]) properties[k] = propsRaw[k]; });
          }
        }
      } catch(err) {}

      // Remove old item first, then add new variant
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: oldKey, quantity: 0 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        var addData = {
          id: newVariantId,
          quantity: qty
        };
        if (Object.keys(properties).length > 0) {
          addData.properties = properties;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(addData)
        });
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        refreshCartDrawer();
      })
      .catch(function(err) {
        console.error('Size change error:', err);
        refreshCartDrawer();
      });
    });

    // Expose openDrawer globally so add-to-cart forms can use it
    window.openCartDrawer = openDrawer;
    window.closeCartDrawer = closeDrawer;
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      refreshCartDrawer();
    })
    .catch(function(err) {
      console.error('Cart update error:', err);
    });
  }

  function refreshCartDrawer() {
    fetch('/?sections=cart-drawer')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = data['cart-drawer'];
        if (!html) return;

        var temp = document.createElement('div');
        temp.innerHTML = html;

        // Update items
        var newItems = temp.querySelector('#cart-drawer-items');
        var oldItems = document.getElementById('cart-drawer-items');
        if (newItems && oldItems) oldItems.innerHTML = newItems.innerHTML;

        // Update footer
        var newFooter = temp.querySelector('#cart-drawer-footer');
        var oldFooter = document.getElementById('cart-drawer-footer');
        if (newFooter && oldFooter) {
          oldFooter.innerHTML = newFooter.innerHTML;
          oldFooter.style.display = newFooter.style.display;
        }

        // Update subtotal
        var newSubtotal = temp.querySelector('#cart-subtotal');
        var oldSubtotal = document.getElementById('cart-subtotal');
        if (newSubtotal && oldSubtotal) oldSubtotal.textContent = newSubtotal.textContent;

        // Update checkout total
        var newCheckout = temp.querySelector('#cart-checkout-total');
        var oldCheckout = document.getElementById('cart-checkout-total');
        if (newCheckout && oldCheckout) oldCheckout.textContent = newCheckout.textContent;

        // Update shipping bar
        var newShipping = temp.querySelector('#cart-shipping-bar');
        var oldShipping = document.getElementById('cart-shipping-bar');
        if (newShipping && oldShipping) oldShipping.innerHTML = newShipping.innerHTML;

        // Update BOGO banner
        var newBogo = temp.querySelector('#cart-drawer-bogo');
        var oldBogo = document.getElementById('cart-drawer-bogo');
        if (newBogo && oldBogo) {
          oldBogo.innerHTML = newBogo.innerHTML;
        } else if (newBogo && !oldBogo) {
          var footer = document.getElementById('cart-drawer-footer');
          if (footer) footer.insertAdjacentHTML('beforebegin', newBogo.outerHTML);
        } else if (!newBogo && oldBogo) {
          oldBogo.remove();
        }

        // Re-init BOGO carousel if it's present
        if (document.getElementById('cart-drawer-bogo')) {
          initBogoCarousel();
        }

        // Update cart count in header
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var countEl = document.getElementById('cart-count');
            if (countEl) countEl.textContent = cart.item_count || '';
          });
      })
      .catch(function(err) {
        console.error('Cart refresh error:', err);
      });
  }

  /* ========================================================================
     Cart Timer
     ======================================================================== */
  function initCartTimer() {
    var timerEl = document.getElementById('cart-timer');
    if (!timerEl) return;

    var minutes = parseInt(timerEl.dataset.minutes) || 10;
    var storageKey = 'uk_cart_timer_end';
    var displayEl = document.getElementById('cart-timer-display');
    if (!displayEl) return;

    var stored = localStorage.getItem(storageKey);
    var endTime;

    if (stored && parseInt(stored) > Date.now()) {
      endTime = parseInt(stored);
    } else {
      endTime = Date.now() + (minutes * 60000);
      localStorage.setItem(storageKey, endTime.toString());
    }

    function updateTimer() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        // Reset timer
        endTime = Date.now() + (minutes * 60000);
        localStorage.setItem(storageKey, endTime.toString());
        diff = endTime - Date.now();
      }

      var m = Math.floor(diff / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      displayEl.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  }

  /* ========================================================================
     FAQ Accordion
     ======================================================================== */
  function initFaqAccordion() {
    document.querySelectorAll('.faq__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq__item');
        var answer = item.querySelector('.faq__answer');
        var isOpen = item.classList.contains('is-open');

        // Close all other items in same accordion
        var accordion = item.closest('.faq__accordion');
        accordion.querySelectorAll('.faq__item.is-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            openItem.querySelector('.faq__question').setAttribute('aria-expanded', 'false');
            openItem.querySelector('.faq__answer').style.maxHeight = '0';
          }
        });

        // Toggle current
        if (isOpen) {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          answer.style.maxHeight = '0';
        } else {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }

  /* ========================================================================
     Country Picker
     ======================================================================== */
  function initCountryPicker() {
    var picker = document.querySelector('.footer__country-picker');
    if (!picker) return;

    var btn = picker.querySelector('.footer__country-btn');
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = picker.classList.contains('is-open');
      picker.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', !isOpen);
    });

    // Close when clicking outside
    document.addEventListener('click', function (e) {
      if (!picker.contains(e.target)) {
        picker.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ========================================================================
     AJAX Add to Cart
     ======================================================================== */
  function initAjaxAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      // Only intercept product forms (action="/cart/add")
      if (!form.matches('form[action="/cart/add"], form[action$="/cart/add"]')) return;

      e.preventDefault();

      var submitBtn = form.querySelector('[type="submit"]');
      var btnText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
      }

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        refreshCartDrawer();
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        }
        if (submitBtn) {
          submitBtn.textContent = 'Added!';
          setTimeout(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = btnText.trim();
          }, 1500);
        }
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = btnText.trim();
        }
      });
    });
  }

  /* ========================================================================
     Product Page
     ======================================================================== */
  function initProductPage() {
    // Image gallery with sliding track
    var thumbs = document.querySelectorAll('.product-page__thumb');
    var slider = document.getElementById('product-slider');
    var mainWrap = document.getElementById('product-main-image-wrap');
    var currentIndex = 0;
    var totalSlides = thumbs.length;

    function goToImage(index) {
      if (!totalSlides) return;
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;
      currentIndex = index;
      slider.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumbs[currentIndex].classList.add('is-active');
    }

    if (thumbs.length && slider) {
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          goToImage(i);
        });
      });
    }

    // Cursor-following arrow on main image
    var cursor = document.getElementById('product-img-cursor');
    var isLeft = false;

    if (mainWrap && cursor && thumbs.length > 1) {
      mainWrap.addEventListener('mousemove', function (e) {
        var rect = mainWrap.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        cursor.style.left = x + 'px';
        cursor.style.top = y + 'px';

        if (x < rect.width / 2) {
          cursor.classList.add('is-left');
          cursor.classList.remove('is-right');
          isLeft = true;
        } else {
          cursor.classList.add('is-right');
          cursor.classList.remove('is-left');
          isLeft = false;
        }
      });

      mainWrap.addEventListener('click', function (e) {
        if (e.target.closest('.product-page__cursor')) return;
        if (isLeft) {
          goToImage(currentIndex - 1);
        } else {
          goToImage(currentIndex + 1);
        }
      });
    }

    // Variant option selection
    var optionBtns = document.querySelectorAll('.product-page__option-btn');
    var variantInput = document.getElementById('product-variant-id');
    if (optionBtns.length && variantInput && typeof productVariantsJSON !== 'undefined') {
      var selectedOptions = {};
      // Init from active buttons
      optionBtns.forEach(function (btn) {
        if (btn.classList.contains('is-active')) {
          selectedOptions[btn.getAttribute('data-option-position')] = btn.getAttribute('data-value');
        }
      });

      optionBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pos = btn.getAttribute('data-option-position');
          var val = btn.getAttribute('data-value');
          var nameHandle = btn.getAttribute('data-option-name');
          selectedOptions[pos] = val;

          // Update active state in same group
          btn.closest('.product-page__option-values').querySelectorAll('.product-page__option-btn').forEach(function (b) {
            b.classList.remove('is-active');
          });
          btn.classList.add('is-active');

          // Update label
          var label = document.getElementById('option-' + nameHandle + '-selected');
          if (label) label.textContent = val;

          // Find matching variant
          var match = productVariantsJSON.find(function (v) {
            return (!selectedOptions['1'] || v.option1 === selectedOptions['1']) &&
                   (!selectedOptions['2'] || v.option2 === selectedOptions['2']) &&
                   (!selectedOptions['3'] || v.option3 === selectedOptions['3']);
          });

          if (match) {
            variantInput.value = match.id;
            // Update price
            var priceEl = document.querySelector('.product-page__price-current');
            var compareEl = document.querySelector('.product-page__price-compare');
            if (priceEl) {
              priceEl.textContent = Shopify.formatMoney ? Shopify.formatMoney(match.price) : (match.price / 100).toFixed(2);
            }
            if (compareEl) {
              if (match.compare_at_price && match.compare_at_price > match.price) {
                compareEl.textContent = Shopify.formatMoney ? Shopify.formatMoney(match.compare_at_price) : (match.compare_at_price / 100).toFixed(2);
                compareEl.style.display = '';
              } else {
                compareEl.style.display = 'none';
              }
            }
            // Update button state
            var addBtn = document.querySelector('.product-page__add-btn');
            if (addBtn) {
              if (match.available) {
                addBtn.disabled = false;
                addBtn.textContent = 'Add to cart';
              } else {
                addBtn.disabled = true;
                addBtn.textContent = 'Sold out';
              }
            }
          }
        });
      });
    }

    // Sticky add to cart bar
    var stickyBar = document.getElementById('sticky-atc');
    var stickyBtn = document.getElementById('sticky-atc-btn');
    var mainAddBtn = document.querySelector('.product-page__add-btn');

    if (stickyBar && mainAddBtn) {
      var showSticky = false;

      function checkStickyAtc() {
        var rect = mainAddBtn.getBoundingClientRect();
        var shouldShow = rect.bottom < 0;
        if (shouldShow !== showSticky) {
          showSticky = shouldShow;
          stickyBar.classList.toggle('is-visible', showSticky);
          stickyBar.setAttribute('aria-hidden', !showSticky);
        }
      }

      window.addEventListener('scroll', checkStickyAtc, { passive: true });

      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          // Trigger the actual product form submit
          var productForm = document.querySelector('form[action="/cart/add"]');
          if (productForm) {
            var evt = new Event('submit', { bubbles: true, cancelable: true });
            productForm.dispatchEvent(evt);
          }
        });
      }
    }

    // Description accordion
    var accBtn = document.querySelector('.product-page__accordion-btn');
    if (accBtn) {
      accBtn.addEventListener('click', function () {
        var content = accBtn.nextElementSibling;
        var isOpen = accBtn.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          accBtn.setAttribute('aria-expanded', 'false');
          content.style.maxHeight = '0';
        } else {
          accBtn.setAttribute('aria-expanded', 'true');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    }
  }

  /* ========================================================================
     Happy Customers Carousel
     ======================================================================== */
  function initHappyCustomersCarousel() {
    var tracks = document.querySelectorAll('.happy-customers__track');
    tracks.forEach(function (track) {
      var speed = parseFloat(track.getAttribute('data-speed')) || 40;
      var items = track.children;
      if (items.length === 0) return;

      var offset = 0;
      var lastTime = null;
      var paused = false;

      // Calculate half-width (original items only, before duplication)
      function getHalfWidth() {
        var halfCount = items.length / 2;
        var totalWidth = 0;
        var gap = parseFloat(getComputedStyle(track).gap) || 12;
        for (var i = 0; i < halfCount; i++) {
          totalWidth += items[i].offsetWidth + gap;
        }
        return totalWidth;
      }

      function animate(timestamp) {
        if (!lastTime) lastTime = timestamp;
        var delta = (timestamp - lastTime) / 1000;
        lastTime = timestamp;

        if (!paused) {
          offset -= speed * delta;
          var halfW = getHalfWidth();
          if (Math.abs(offset) >= halfW) {
            offset += halfW;
          }
          track.style.transform = 'translateX(' + offset + 'px)';
        }
        requestAnimationFrame(animate);
      }

      // Pause on hover
      track.closest('.happy-customers__track-wrapper').addEventListener('mouseenter', function () { paused = true; });
      track.closest('.happy-customers__track-wrapper').addEventListener('mouseleave', function () { paused = false; });

      requestAnimationFrame(animate);
    });
  }

  /* ========================================================================
     Search Overlay
     ======================================================================== */
  function initSearchOverlay() {
    var trigger = document.getElementById('search-trigger');
    var overlay = document.getElementById('search-overlay');
    var closeBtn = document.getElementById('search-overlay-close');
    var clearBtn = document.getElementById('search-clear');
    var input = document.getElementById('search-overlay-input');
    var resultsEl = document.getElementById('search-results');
    var tabs = overlay ? overlay.querySelectorAll('.search-overlay__tab') : [];
    if (!trigger || !overlay) return;

    var activeTab = 'products';
    var lastQuery = '';
    var debounceTimer = null;
    var cachedResults = { products: [], suggestions: [], collections: [] };
    var tabsEl = overlay ? overlay.querySelector('.search-overlay__tabs') : null;

    function openSearch() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      setTimeout(function() { if (input) input.focus(); }, 80);
    }

    function closeSearch() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
    }

    function formatMoney(cents) {
      var amount = (parseFloat(cents) / 100).toFixed(2);
      return '£' + amount;
    }

    function renderProducts(products) {
      if (!products.length) {
        return '<p class="search-overlay__empty">No products found</p>';
      }
      return products.map(function(p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img class="search-result-item__image" src="' + p.featured_image.url + '" alt="' + (p.featured_image.alt || p.title) + '" loading="lazy">'
          : '<div class="search-result-item__image"></div>';
        var price = '<span class="search-result-item__price">' + formatMoney(p.price) + '</span>';
        var compare = p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price)
          ? '<span class="search-result-item__compare">' + formatMoney(p.compare_at_price_max) + '</span>'
          : '';
        return '<a href="' + p.url + '" class="search-result-item">' +
          img +
          '<div class="search-result-item__info">' +
            '<div class="search-result-item__title">' + p.title + '</div>' +
            '<div class="search-result-item__prices">' + price + compare + '</div>' +
          '</div></a>';
      }).join('');
    }

    function renderSuggestions(queries) {
      if (!queries.length) {
        return '<p class="search-overlay__empty">No suggestions found</p>';
      }
      return queries.map(function(q) {
        return '<a href="' + q.url + '" class="search-result-text">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#aaa" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>' +
          q.text + '</a>';
      }).join('');
    }

    function renderCollections(collections) {
      if (!collections.length) {
        return '<p class="search-overlay__empty">No collections found</p>';
      }
      return collections.map(function(c) {
        var img = c.featured_image && c.featured_image.url
          ? '<img class="search-result-item__image" src="' + c.featured_image.url + '" alt="' + c.title + '" loading="lazy">'
          : '<div class="search-result-item__image"></div>';
        return '<a href="' + c.url + '" class="search-result-item">' +
          img +
          '<div class="search-result-item__info"><div class="search-result-item__title">' + c.title + '</div></div></a>';
      }).join('');
    }

    function showTab(tab) {
      activeTab = tab;
      tabs.forEach(function(t) {
        t.classList.toggle('is-active', t.dataset.tab === tab);
      });
      if (!lastQuery) { resultsEl.innerHTML = ''; return; }
      if (tab === 'products') resultsEl.innerHTML = renderProducts(cachedResults.products);
      else if (tab === 'suggestions') resultsEl.innerHTML = renderSuggestions(cachedResults.suggestions);
      else if (tab === 'collections') resultsEl.innerHTML = renderCollections(cachedResults.collections);
    }

    function fetchResults(query) {
      if (!query) {
        cachedResults = { products: [], suggestions: [], collections: [] };
        resultsEl.innerHTML = '';
        if (tabsEl) tabsEl.classList.remove('is-visible');
        return;
      }
      if (tabsEl) tabsEl.classList.add('is-visible');
      var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product,query,collection&resources[limit]=8';
      fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var res = data.resources && data.resources.results || {};
          cachedResults.products = res.products || [];
          cachedResults.suggestions = res.queries || [];
          cachedResults.collections = res.collections || [];
          showTab(activeTab);
        })
        .catch(function() {
          resultsEl.innerHTML = '<p class="search-overlay__empty">Something went wrong</p>';
        });
    }

    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      overlay.classList.contains('is-open') ? closeSearch() : openSearch();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeSearch);

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        input.value = '';
        clearBtn.classList.remove('is-visible');
        lastQuery = '';
        cachedResults = { products: [], suggestions: [], collections: [] };
        resultsEl.innerHTML = '';
        if (tabsEl) tabsEl.classList.remove('is-visible');
        input.focus();
      });
    }

    if (input) {
      input.addEventListener('input', function() {
        var q = input.value.trim();
        clearBtn && clearBtn.classList.toggle('is-visible', q.length > 0);
        if (q === lastQuery) return;
        lastQuery = q;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() { fetchResults(q); }, 280);
      });
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() { showTab(tab.dataset.tab); });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeSearch();
    });
  }

  /* ========================================================================
     BOGO Carousel
     ======================================================================== */
  function initBogoCarousel() {
    var bogoEl = document.getElementById('cart-drawer-bogo');
    if (!bogoEl) return;

    var prevBtn = bogoEl.querySelector('.bogo__arrow--prev');
    var nextBtn = bogoEl.querySelector('.bogo__arrow--next');

    function getSlidesEl() {
      return document.getElementById('bogo-slides');
    }
    var collection = bogoEl.dataset.collection || 'all';

    var products = [];
    var current = 0;

    function fmt(price) {
      return '£' + parseFloat(price).toFixed(2);
    }

    function renderSlide(index, direction) {
      var p = products[index];
      if (!p) return;

      var variants = p.variants || [];
      var firstAvail = variants.find(function(v) { return v.available; }) || variants[0] || {};
      var price = firstAvail.price || p.price_min || '0';
      var compare = firstAvail.compare_at_price;
      var savings = compare && parseFloat(compare) > parseFloat(price)
        ? Math.round((parseFloat(compare) - parseFloat(price)) / parseFloat(compare) * 100)
        : 0;

      var sizeOpts = variants.length > 1
        ? variants.map(function(v) {
            return '<option value="' + v.id + '"' + (!v.available ? ' disabled' : '') + '>' + v.title + (!v.available ? ' - Sold out' : '') + '</option>';
          }).join('')
        : '';

      var imgUrl = p.images && p.images[0] ? p.images[0].src : '';

      var html = '<div class="bogo__slide">' +
        (imgUrl ? '<img class="bogo__product-image" src="' + imgUrl + '" alt="' + p.title + '" loading="lazy">' : '<div class="bogo__product-image"></div>') +
        '<div class="bogo__product-info">' +
          '<div class="bogo__product-title">' + p.title + '</div>' +
          '<div class="bogo__product-prices">' +
            '<span class="bogo__product-price">' + fmt(price) + '</span>' +
            (compare && savings ? '<span class="bogo__product-compare">' + fmt(compare) + '</span><span class="bogo__product-savings">You save ' + savings + '%</span>' : '') +
          '</div>' +
          (sizeOpts ? '<div class="bogo__product-size">Size: <select class="bogo__size-select">' + sizeOpts + '</select></div>' : '') +
          '<button type="button" class="bogo__add-btn" data-variant="' + firstAvail.id + '">Add to cart</button>' +
        '</div></div>';

      var el = getSlidesEl();
      if (!el) return;
      var oldSlide = el.querySelector('.bogo__slide');
      if (oldSlide && direction) {
        var outClass = direction === 'next' ? 'slide-out-left' : 'slide-out-right';
        oldSlide.classList.add(outClass);
        setTimeout(function() {
          var el2 = getSlidesEl();
          if (!el2) return;
          el2.innerHTML = html;
          var newSlide = el2.querySelector('.bogo__slide');
          if (newSlide) newSlide.classList.add(direction === 'next' ? 'slide-in-right' : 'slide-in-left');
          bindAddToCart();
        }, 220);
      } else {
        el.innerHTML = html;
        bindAddToCart();
      }
    }

    function bindAddToCart() {
      var el = getSlidesEl();
      if (!el) return;
      var btn = el.querySelector('.bogo__add-btn');
      var sizeSelect = el.querySelector('.bogo__size-select');
      if (!btn) return;

      btn.addEventListener('click', function() {
        var variantId = sizeSelect ? parseInt(sizeSelect.value) : parseInt(btn.dataset.variant);
        btn.textContent = 'Adding...';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          btn.textContent = 'Added!';
          setTimeout(function() {
            btn.textContent = 'Add to cart';
            btn.disabled = false;
          }, 1500);
          refreshCartDrawer();
        })
        .catch(function() {
          btn.textContent = 'Add to cart';
          btn.disabled = false;
        });
      });
    }

    var fetchUrl = collection && collection !== 'all'
      ? '/collections/' + collection + '/products.json?limit=20'
      : '/products.json?limit=20';

    fetch(fetchUrl)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        products = data.products || [];
        if (!products.length && fetchUrl !== '/products.json?limit=20') {
          return fetch('/products.json?limit=20').then(function(r) { return r.json(); }).then(function(d) {
            products = d.products || [];
          });
        }
      })
      .then(function() {
        if (products.length) {
          current = Math.floor(Math.random() * products.length);
          renderSlide(current);
        } else {
          var el = getSlidesEl();
          if (el) el.innerHTML = '<p class="bogo__loading">No products found</p>';
        }
      })
      .catch(function() { var el = getSlidesEl(); if (el) el.innerHTML = ''; });

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        current = (current - 1 + products.length) % products.length;
        renderSlide(current, 'prev');
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        current = (current + 1) % products.length;
        renderSlide(current, 'next');
      });
    }
  }

  /* ========================================================================
     Initialize everything on DOM ready
     ======================================================================== */
  function init() {
    initCountdown();
    initStickyHeader();
    initMobileMenu();
    initCartDrawer();
    initBogoCarousel();
    initSearchOverlay();
    initCartTimer();
    initFaqAccordion();
    initCountryPicker();
    initAjaxAddToCart();
    initProductPage();
    initHappyCustomersCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
